/// <amd-module name="SuiteCommerce.Blog.BlogHome"/>
define("SuiteCommerce.Blog.BlogHome", ["require", "exports", "Utils", "SuiteCommerce.Blog.BlogHome.View"], function (require, exports, Utils_1, BlogHome_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pageTypeComponent = container.getComponent('PageType');
            this.registerPageTypes(pageTypeComponent);
        },
        registerPageTypes: function (pageTypeComponent) {
            var taxonomyNavigationPattern = /^blog\/(category|term|tag|author)\/([A-Za-z0-9\-.]+)(\/?)(\?(.*)$)?/;
            pageTypeComponent.registerPageType({
                name: 'ext-blog-list',
                routes: ['blog(/)', 'blog?*queryParams', taxonomyNavigationPattern],
                view: BlogHome_View_1.BlogHomeView,
                defaultTemplate: {
                    name: 'sc_blog_home_default_layout.tpl',
                    displayName: 'Blog Post List',
                    thumbnail: Utils_1.getAbsoluteUrl(getExtensionAssetsPath('img/ic_cct_sc_blog_post_list.svg')),
                },
            });
        },
    };
});
